const customerProfitBackdrop = require('./customerProfit-backdrop')
const customerProfitConfirmation = require('./customerProfit-confirmation')
const customerProfitDialog = require('./customerProfit-dialog')
const customerProfitDt = require('./customerProfit-dt')
const customerProfitFullcont = require('./customerProfit-fullcont')
const customerProfitMenu = require('./customerProfit-menu')
const customerProfitPage = require('./customerProfit-page')
const customerProfitSnack = require('./customerProfit-snack')
const customerProfitFetch = require('./customerProfit-fetch')
const saleFullcont2 = require('./sale2/sale-fullcont')
const mtsaleFullcont2 = require('./sale2/sale-fullcont-multitable')

export function start(detail) {  //console.log('goku-dt 5>', detail)

      obj[detail.elem].start(detail)

}/**/

const obj = {

      backdrop: { start: (detail) => { customerProfitBackdrop.start(detail) } },
      confirmation: { start: (detail) => { customerProfitConfirmation.start(detail) } },
      dialog: { start: (detail) => { customerProfitDialog.start(detail) } },
      dt: { start: (detail) => { customerProfitDt.start(detail) } },
      fullcont: { start: (detail) => { customerProfitFullcont.start(detail) } },
      menu: { start: (detail) => { customerProfitMenu.start(detail) } },
      page: { start: (detail) => { customerProfitPage.start(detail) } },
      snack: { start: (detail) => { customerProfitSnack.start(detail) } },
      fetch: { start: (detail) => { customerProfitFetch.start(detail) } },
      saleFullcont2: { start: (detail) => { saleFullcont2.start(detail) } },
      mtsaleFullcont2: { start: (detail) => { mtsaleFullcont2.start(detail) } },
}